import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a href='https://github.com/codehackerone' className='link footer__link'>
      Copyright &copy; Soumyajit Datta 2026.
    </a>
  </footer>
)

export default Footer
